import React from 'react';
import { InterviewAutomaticNote } from '../../../../entities/InterviewAutomaticNote';
import { DeprecatedPanel } from '../../../DeprecatedPanel';
import { IconSpan } from '../../../IconSpan';
import styles from './styles.module.scss';
import { CopyButton } from '../../../CopyButton';

interface PropTypes {
  typeName: string;
  automaticNotes: InterviewAutomaticNote[];
}
export function AutomaticNotesBlock(props: PropTypes) {
  if (!props.automaticNotes.length) {
    return null;
  }

  const automaticNotes = props.automaticNotes.sort((a, b) => b.order - a.order);

  return (
    <div className='col-12'>
      <div className='row g-0 align-items-center'>
        <div className='col mt-2 ps-0'>
          <DeprecatedPanel className='bg-gray p-3 fs-5'>
            <div className='d-flex mb-1 justify-content-between'>
              <div className='d-flex gap-1 align-items-center'>
                <IconSpan
                  icon={{ name: 'bi-stars', className: 'text-info' }}
                  spanText={props.typeName}
                  className='fw-semibold'
                />
                <span className='text-dark-200'>- AI Note</span>
              </div>
              <CopyButton
                textToBeCopied={automaticNotes
                  .map((note) => note.text)
                  .join('\n')}
              />
            </div>
            {automaticNotes.map((note) => (
              <div
                key={note.id}
                data-testid={`NoteBlock-automatic-note-${note.id}`}
                className={styles['automatic-notes-block']}
              >
                {note.text}
              </div>
            ))}
          </DeprecatedPanel>
        </div>
      </div>
    </div>
  );
}
